export default {
  name: '公司概况',
  children: [{ menuId: 1, name: '公司介绍', url: 'introduction' }],
}
